module.exports = __webpack_public_path__ + "static/media/defaultAvatarMale.edd5e438.jpg";